export const isPosSummaryAllZero = (posSummary: any): boolean => {
  if (!posSummary) return true;

  return (
    (posSummary.scratcher_count ?? 0) === 0 &&
    (posSummary.scratcher_sales ?? 0) === 0 &&
    (posSummary.lotto_sales ?? 0) === 0 &&
    (posSummary.payout ?? 0) === 0
  );
};

export const isLottoSummaryAllZero = (lottoSummary: any): boolean => {
  if (!lottoSummary) return true;

  return (
    (lottoSummary.sales ?? 0) === 0 &&
    (lottoSummary.payouts_total ?? 0) === 0 &&
    (lottoSummary.payouts_count ?? 0) === 0 &&
    (lottoSummary.lotto_payouts_amount ?? 0) === 0 &&
    (lottoSummary.lotto_payouts_count ?? 0) === 0 &&
    (lottoSummary.scratcher_payouts_amount ?? 0) === 0 &&
    (lottoSummary.scratcher_payouts_count ?? 0) === 0 &&
    (lottoSummary.scratcher_free_tickets_paid_count ?? 0) === 0 &&
    (lottoSummary.scratcher_free_tickets_paid_amount ?? 0) === 0
  );
};

export interface AuditMissingSourceOptions {
  hasPosType: boolean;
  isLottoAuthorized: boolean;
  isDayInProgress?: boolean;
}

export interface AuditDataAvailability {
  auditCount: number;
  isAuditMissing: boolean;
  isPosMissing: boolean;
  isLottoMissing: boolean;
  hasPosData: boolean;
  hasLottoData: boolean;
  missingSources: string[];
  hasMissingSources: boolean;
  canShowScratcherVariance: boolean;
  canShowLottoVariance: boolean;
  canShowOverallVariance: boolean;
}

export const getAuditDataAvailability = (
  day: any,
  options: AuditMissingSourceOptions
): AuditDataAvailability => {
  const emptyAvailability: AuditDataAvailability = {
    auditCount: 0,
    isAuditMissing: false,
    isPosMissing: true,
    isLottoMissing: true,
    hasPosData: false,
    hasLottoData: false,
    missingSources: [],
    hasMissingSources: false,
    canShowScratcherVariance: false,
    canShowLottoVariance: false,
    canShowOverallVariance: false,
  };

  if (!day) {
    return emptyAvailability;
  }

  const totals = day.auditTotals;
  const auditCount = totals?.audit?.audit_count ?? 0;
  const isAuditMissing = Boolean(day.auditMissing) && auditCount <= 0;
  const isPosMissing = isPosSummaryAllZero(totals?.pos);
  const isLottoMissing = isLottoSummaryAllZero(totals?.lotto);
  const hasPosData = options.hasPosType && !isPosMissing;
  const hasLottoData = options.isLottoAuthorized && !isLottoMissing;
  const missingSources: string[] = [];
  const isDayInProgress = Boolean(options.isDayInProgress);

  if (isAuditMissing) {
    missingSources.push("Audit");
  }

  if (options.hasPosType && isPosMissing) {
    missingSources.push("POS");
  }

  if (options.isLottoAuthorized && isLottoMissing) {
    missingSources.push("Lotto");
  }

  return {
    auditCount,
    isAuditMissing,
    isPosMissing,
    isLottoMissing,
    hasPosData,
    hasLottoData,
    missingSources,
    hasMissingSources: missingSources.length > 0,
    canShowScratcherVariance: !isDayInProgress && hasPosData && !isAuditMissing,
    canShowLottoVariance: !isDayInProgress && hasPosData && hasLottoData,
    canShowOverallVariance: !isDayInProgress && !isAuditMissing && hasPosData && hasLottoData,
  };
};

export const getAuditMissingSources = (
  day: any,
  options: AuditMissingSourceOptions
): string[] => {
  return getAuditDataAvailability(day, options).missingSources;
};
